// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Premium Ops Dashboard Redesign */
.redesign-console {
    background: transparent;
    padding: 0;
    gap: 1.5rem;
}

.monitoring-console-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 0.5rem;
}

.mch-left {
    display: flex;
    align-items: center;
    gap: 8px;
}

.mch-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: var(--text-main);
}

.mch-right {
    display: flex;
    align-items: center;
    gap: 8px;
}

.mch-time {
    font-size: 0.75rem;
    color: var(--text-muted);
}

/* Base Cards */
.status-card-ref, .ssh-summary-card-ref {
    border-radius: 16px !important;
    overflow: hidden;
    position: relative;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

.status-card-ref.blue-gradient {
    background: linear-gradient(180deg, rgba(248, 250, 252, 0.8) 0%, rgba(255, 255, 255, 0.9) 100%) !important;
    border: 1px solid rgba(226, 232, 240, 0.8) !important;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.6) !important;
}

html[data-theme='dark'] .status-card-ref.blue-gradient {
    background: linear-gradient(180deg, rgba(15, 23, 42, 0.8) 0%, rgba(30, 41, 59, 0.9) 100%) !important;
    border: 1px solid rgba(51, 65, 85, 0.8) !important;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.05) !important;
}

.ssh-summary-card-ref.lavender-accent {
    background: linear-gradient(180deg, rgba(245, 243, 255, 0.8) 0%, rgba(255, 255, 255, 0.9) 100%) !important;
    border: 1px solid rgba(221, 214, 254, 0.5) !important;
    box-shadow: 0 10px 30px rgba(139, 92, 246, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.6) !important;
}

html[data-theme='dark'] .ssh-summary-card-ref.lavender-accent {
    background: linear-gradient(180deg, rgba(30, 27, 75, 0.6) 0%, rgba(15, 23, 42, 0.9) 100%) !important;
    border: 1px solid rgba(67, 56, 202, 0.3) !important;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.05) !important;
}

/* Headers */
.status-header-min.left {
    padding: 1.25rem 1.5rem 0.5rem;
    font-size: 0.95rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--text-main);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    margin-bottom: 1rem;
}

html[data-theme='dark'] .status-header-min.left {
    border-bottom-color: rgba(255, 255, 255, 0.05);
}

.redesign-console .refresh-icon-min {
    color: var(--text-muted);
    cursor: pointer;
    transition: transform 0.3s ease;
}

.redesign-console .refresh-icon-min:hover {
    transform: rotate(180deg);
}

/* VPN Offline Body */
.vpn-status-body-redesign {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.status-visualization-redesign {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 1.5rem 0;
    position: relative;
}

.icon-circle-clear {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.8);
    border: 1px solid rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.25rem;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
    position: relative;
    z-index: 2;
}

html[data-theme='dark'] .icon-circle-clear {
    background: rgba(15, 23, 42, 0.8);
    border-color: rgba(255, 255, 255, 0.08);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
}

.icon-circle-clear.offline {
    border-color: rgba(239, 68, 68, 0.3);
    color: #ef4444;
}

/* Glowing rings */
.icon-circle-clear::before {
    content: '';
    position: absolute;
    inset: -10px;
    border-radius: 50%;
    border: 1px dashed rgba(100, 116, 139, 0.2);
    animation: rotate 10s linear infinite;
    z-index: -1;
}

.icon-circle-clear.offline::before {
    border-color: rgba(239, 68, 68, 0.3);
    animation: rotate 10s linear infinite, pulseRedOp 2s ease-in-out infinite alternate;
}

@keyframes rotate {
    100% { transform: rotate(360deg); }
}

@keyframes pulseRedOp {
    0% { opacity: 0.3; }
    100% { opacity: 1; }
}

.status-lozenge-red {
    background: rgba(239, 68, 68, 0.1);
    border: 1px solid rgba(239, 68, 68, 0.2);
    color: #ef4444;
    padding: 6px 16px;
    border-radius: 8px;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.1);
    backdrop-filter: blur(4px);
}

html[data-theme='dark'] .status-lozenge-red {
    background: rgba(239, 68, 68, 0.15);
}

/* Meta Grid */
.status-metas-grid-redesign {
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 1rem;
    padding: 0 1.5rem 1.5rem;
}

.meta-item-redesign {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(255, 255, 255, 0.6);
    flex: 1 1;
    padding: 1.25rem 1rem;
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.04);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
}

html[data-theme='dark'] .meta-item-redesign {
    background: rgba(30, 41, 59, 0.4);
    border-color: rgba(255, 255, 255, 0.03);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.meta-item-redesign:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
    border-color: rgba(0, 0, 0, 0.08);
}

html[data-theme='dark'] .meta-item-redesign:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
    border-color: rgba(255, 255, 255, 0.08);
}

.meta-item-redesign::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(100, 116, 139, 0.2), transparent);
}

.meta-icon-container {
    margin-bottom: 12px;
    filter: drop-shadow(0 4px 6px rgba(0,0,0,0.05));
    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.meta-item-redesign:hover .meta-icon-container {
    transform: scale(1.15) translateY(-2px);
}

.meta-info-redesign {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
}

.meta-status-circle {
    width: 6px;
    height: 6px;
    border-radius: 50%;
}

.meta-status-circle.offline {
    background: #ef4444;
    box-shadow: 0 0 8px rgba(239, 68, 68, 0.8);
}

.meta-info-redesign .lbl {
    font-size: 0.7rem;
    font-weight: 700;
    color: var(--text-secondary);
    letter-spacing: 0.05em;
}

.val-redesign.error {
    color: #ef4444;
    font-weight: 800;
    font-size: 0.75rem;
    letter-spacing: 0.05em;
    background: transparent;
    padding: 0;
    box-shadow: none;
}

/* SSH Items List */
.ssh-body-redesign {
    padding: 0 1.5rem 1.5rem;
}

.ssh-items-list-ref {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.ssh-slate-item {
    background: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.02);
}

html[data-theme='dark'] .ssh-slate-item {
    background: rgba(30, 41, 59, 0.5);
    border-color: rgba(255, 255, 255, 0.04);
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.ssh-slate-item:hover {
    background: rgba(255, 255, 255, 1);
    transform: translateX(4px);
    border-color: rgba(139, 92, 246, 0.3);
    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.08);
}

html[data-theme='dark'] .ssh-slate-item:hover {
    background: rgba(30, 41, 59, 0.9);
    border-color: rgba(139, 92, 246, 0.4);
    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.15);
}

.ssh-slate-item.active {
    background: rgba(236, 253, 245, 0.65); /* Translucent greenish-mint */
    backdrop-filter: blur(40px) saturate(180%);
    -webkit-backdrop-filter: blur(40px) saturate(180%);
    border: 1px solid #10B981;
    box-shadow: 
        0 8px 24px rgba(16, 185, 129, 0.15),
        inset 0 1px 1px rgba(255, 255, 255, 0.8);
}

html[data-theme='dark'] .ssh-slate-item.active {
    background: rgba(6, 78, 59, 0.3);
    border-color: #10B981;
    box-shadow: 
        0 8px 24px rgba(16, 185, 129, 0.2),
        inset 0 1px 1px rgba(255, 255, 255, 0.08);
}

.ssh-slate-item.idle {
    background: rgba(254, 242, 242, 0.65); /* Translucent red */
    backdrop-filter: blur(40px) saturate(180%);
    -webkit-backdrop-filter: blur(40px) saturate(180%);
    border: 1px solid #EF4444;
    box-shadow: 
        0 8px 24px rgba(239, 68, 68, 0.15),
        inset 0 1px 1px rgba(255, 255, 255, 0.8);
}

html[data-theme='dark'] .ssh-slate-item.idle {
    background: rgba(127, 29, 29, 0.3);
    border-color: #EF4444;
    box-shadow: 
        0 8px 24px rgba(239, 68, 68, 0.2),
        inset 0 1px 1px rgba(255, 255, 255, 0.08);
}

.ssh-slate-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(180deg, #8b5cf6, #3b82f6);
    opacity: 0.5;
    transition: opacity 0.3s ease;
}

.ssh-slate-item:hover::before {
    opacity: 1;
}

.ssh-empty-state-redesign {
    padding: 2rem 1rem;
    text-align: center;
}

.ssh-empty-main {
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--text-main);
    margin: 0 0 0.5rem 0;
}

.ssh-empty-sub {
    font-size: 0.8rem;
    color: var(--text-muted);
    margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/dms/PrivateConnectivityRedesign.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,uBAAuB;IACvB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA,eAAe;AACf;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,mCAAmC;IACnC,6DAA6D;AACjE;;AAEA;IACI,0GAA0G;IAC1G,qDAAqD;IACrD,8FAA8F;AAClG;;AAEA;IACI,oGAAoG;IACpG,kDAAkD;IAClD,8FAA8F;AAClG;;AAEA;IACI,0GAA0G;IAC1G,qDAAqD;IACrD,mGAAmG;AACvG;;AAEA;IACI,oGAAoG;IACpG,mDAAmD;IACnD,8FAA8F;AAClG;;AAEA,YAAY;AACZ;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,0CAA0C;IAC1C,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,uCAAuC;IACvC,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,mFAAmF;AACvF;;AAEA;IACI,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,KAAK,YAAY,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,6CAA6C;IAC7C,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;AACvC;;AAEA,cAAc;AACd;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oCAAoC;IACpC,SAAO;IACP,qBAAqB;IACrB,mBAAmB;IACnB,qCAAqC;IACrC,0CAA0C;IAC1C,iDAAiD;IACjD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,uCAAuC;IACvC,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,iCAAiC;AACrC;;AAEA;IACI,yCAAyC;IACzC,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,sFAAsF;AAC1F;;AAEA;IACI,mBAAmB;IACnB,+CAA+C;IAC/C,4DAA4D;AAChE;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,iCAAiC;IACjC,uCAAuC;IACvC,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;IAClC,0BAA0B;IAC1B,qCAAqC;IACrC,+CAA+C;AACnD;;AAEA;IACI,iCAAiC;IACjC,qCAAqC;IACrC,+CAA+C;AACnD;;AAEA;IACI,qCAAqC,EAAE,8BAA8B;IACrE,0CAA0C;IAC1C,kDAAkD;IAClD,yBAAyB;IACzB;;gDAE4C;AAChD;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB;;iDAE6C;AACjD;;AAEA;IACI,qCAAqC,EAAE,oBAAoB;IAC3D,0CAA0C;IAC1C,kDAAkD;IAClD,yBAAyB;IACzB;;gDAE4C;AAChD;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB;;iDAE6C;AACjD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,UAAU;IACV,qDAAqD;IACrD,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,SAAS;AACb","sourcesContent":["/* Premium Ops Dashboard Redesign */\n.redesign-console {\n    background: transparent;\n    padding: 0;\n    gap: 1.5rem;\n}\n\n.monitoring-console-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 0.5rem;\n}\n\n.mch-left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.mch-title {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: var(--text-main);\n}\n\n.mch-right {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.mch-time {\n    font-size: 0.75rem;\n    color: var(--text-muted);\n}\n\n/* Base Cards */\n.status-card-ref, .ssh-summary-card-ref {\n    border-radius: 16px !important;\n    overflow: hidden;\n    position: relative;\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;\n}\n\n.status-card-ref.blue-gradient {\n    background: linear-gradient(180deg, rgba(248, 250, 252, 0.8) 0%, rgba(255, 255, 255, 0.9) 100%) !important;\n    border: 1px solid rgba(226, 232, 240, 0.8) !important;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.6) !important;\n}\n\nhtml[data-theme='dark'] .status-card-ref.blue-gradient {\n    background: linear-gradient(180deg, rgba(15, 23, 42, 0.8) 0%, rgba(30, 41, 59, 0.9) 100%) !important;\n    border: 1px solid rgba(51, 65, 85, 0.8) !important;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.05) !important;\n}\n\n.ssh-summary-card-ref.lavender-accent {\n    background: linear-gradient(180deg, rgba(245, 243, 255, 0.8) 0%, rgba(255, 255, 255, 0.9) 100%) !important;\n    border: 1px solid rgba(221, 214, 254, 0.5) !important;\n    box-shadow: 0 10px 30px rgba(139, 92, 246, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.6) !important;\n}\n\nhtml[data-theme='dark'] .ssh-summary-card-ref.lavender-accent {\n    background: linear-gradient(180deg, rgba(30, 27, 75, 0.6) 0%, rgba(15, 23, 42, 0.9) 100%) !important;\n    border: 1px solid rgba(67, 56, 202, 0.3) !important;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.05) !important;\n}\n\n/* Headers */\n.status-header-min.left {\n    padding: 1.25rem 1.5rem 0.5rem;\n    font-size: 0.95rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: var(--text-main);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n    margin-bottom: 1rem;\n}\n\nhtml[data-theme='dark'] .status-header-min.left {\n    border-bottom-color: rgba(255, 255, 255, 0.05);\n}\n\n.redesign-console .refresh-icon-min {\n    color: var(--text-muted);\n    cursor: pointer;\n    transition: transform 0.3s ease;\n}\n\n.redesign-console .refresh-icon-min:hover {\n    transform: rotate(180deg);\n}\n\n/* VPN Offline Body */\n.vpn-status-body-redesign {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n}\n\n.status-visualization-redesign {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 1.5rem 0;\n    position: relative;\n}\n\n.icon-circle-clear {\n    width: 72px;\n    height: 72px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.8);\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1.25rem;\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);\n    position: relative;\n    z-index: 2;\n}\n\nhtml[data-theme='dark'] .icon-circle-clear {\n    background: rgba(15, 23, 42, 0.8);\n    border-color: rgba(255, 255, 255, 0.08);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);\n}\n\n.icon-circle-clear.offline {\n    border-color: rgba(239, 68, 68, 0.3);\n    color: #ef4444;\n}\n\n/* Glowing rings */\n.icon-circle-clear::before {\n    content: '';\n    position: absolute;\n    inset: -10px;\n    border-radius: 50%;\n    border: 1px dashed rgba(100, 116, 139, 0.2);\n    animation: rotate 10s linear infinite;\n    z-index: -1;\n}\n\n.icon-circle-clear.offline::before {\n    border-color: rgba(239, 68, 68, 0.3);\n    animation: rotate 10s linear infinite, pulseRedOp 2s ease-in-out infinite alternate;\n}\n\n@keyframes rotate {\n    100% { transform: rotate(360deg); }\n}\n\n@keyframes pulseRedOp {\n    0% { opacity: 0.3; }\n    100% { opacity: 1; }\n}\n\n.status-lozenge-red {\n    background: rgba(239, 68, 68, 0.1);\n    border: 1px solid rgba(239, 68, 68, 0.2);\n    color: #ef4444;\n    padding: 6px 16px;\n    border-radius: 8px;\n    font-size: 0.75rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.1);\n    backdrop-filter: blur(4px);\n}\n\nhtml[data-theme='dark'] .status-lozenge-red {\n    background: rgba(239, 68, 68, 0.15);\n}\n\n/* Meta Grid */\n.status-metas-grid-redesign {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    gap: 1rem;\n    padding: 0 1.5rem 1.5rem;\n}\n\n.meta-item-redesign {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background: rgba(255, 255, 255, 0.6);\n    flex: 1;\n    padding: 1.25rem 1rem;\n    border-radius: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.04);\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n    overflow: hidden;\n}\n\nhtml[data-theme='dark'] .meta-item-redesign {\n    background: rgba(30, 41, 59, 0.4);\n    border-color: rgba(255, 255, 255, 0.03);\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n}\n\n.meta-item-redesign:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);\n    border-color: rgba(0, 0, 0, 0.08);\n}\n\nhtml[data-theme='dark'] .meta-item-redesign:hover {\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);\n    border-color: rgba(255, 255, 255, 0.08);\n}\n\n.meta-item-redesign::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background: linear-gradient(90deg, transparent, rgba(100, 116, 139, 0.2), transparent);\n}\n\n.meta-icon-container {\n    margin-bottom: 12px;\n    filter: drop-shadow(0 4px 6px rgba(0,0,0,0.05));\n    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.meta-item-redesign:hover .meta-icon-container {\n    transform: scale(1.15) translateY(-2px);\n}\n\n.meta-info-redesign {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 10px;\n}\n\n.meta-status-circle {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n}\n\n.meta-status-circle.offline {\n    background: #ef4444;\n    box-shadow: 0 0 8px rgba(239, 68, 68, 0.8);\n}\n\n.meta-info-redesign .lbl {\n    font-size: 0.7rem;\n    font-weight: 700;\n    color: var(--text-secondary);\n    letter-spacing: 0.05em;\n}\n\n.val-redesign.error {\n    color: #ef4444;\n    font-weight: 800;\n    font-size: 0.75rem;\n    letter-spacing: 0.05em;\n    background: transparent;\n    padding: 0;\n    box-shadow: none;\n}\n\n/* SSH Items List */\n.ssh-body-redesign {\n    padding: 0 1.5rem 1.5rem;\n}\n\n.ssh-items-list-ref {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.ssh-slate-item {\n    background: rgba(255, 255, 255, 0.7);\n    border: 1px solid rgba(0, 0, 0, 0.05);\n    border-radius: 10px;\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.02);\n}\n\nhtml[data-theme='dark'] .ssh-slate-item {\n    background: rgba(30, 41, 59, 0.5);\n    border-color: rgba(255, 255, 255, 0.04);\n    box-shadow: 0 2px 8px rgba(0,0,0,0.2);\n}\n\n.ssh-slate-item:hover {\n    background: rgba(255, 255, 255, 1);\n    transform: translateX(4px);\n    border-color: rgba(139, 92, 246, 0.3);\n    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.08);\n}\n\nhtml[data-theme='dark'] .ssh-slate-item:hover {\n    background: rgba(30, 41, 59, 0.9);\n    border-color: rgba(139, 92, 246, 0.4);\n    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.15);\n}\n\n.ssh-slate-item.active {\n    background: rgba(236, 253, 245, 0.65); /* Translucent greenish-mint */\n    backdrop-filter: blur(40px) saturate(180%);\n    -webkit-backdrop-filter: blur(40px) saturate(180%);\n    border: 1px solid #10B981;\n    box-shadow: \n        0 8px 24px rgba(16, 185, 129, 0.15),\n        inset 0 1px 1px rgba(255, 255, 255, 0.8);\n}\n\nhtml[data-theme='dark'] .ssh-slate-item.active {\n    background: rgba(6, 78, 59, 0.3);\n    border-color: #10B981;\n    box-shadow: \n        0 8px 24px rgba(16, 185, 129, 0.2),\n        inset 0 1px 1px rgba(255, 255, 255, 0.08);\n}\n\n.ssh-slate-item.idle {\n    background: rgba(254, 242, 242, 0.65); /* Translucent red */\n    backdrop-filter: blur(40px) saturate(180%);\n    -webkit-backdrop-filter: blur(40px) saturate(180%);\n    border: 1px solid #EF4444;\n    box-shadow: \n        0 8px 24px rgba(239, 68, 68, 0.15),\n        inset 0 1px 1px rgba(255, 255, 255, 0.8);\n}\n\nhtml[data-theme='dark'] .ssh-slate-item.idle {\n    background: rgba(127, 29, 29, 0.3);\n    border-color: #EF4444;\n    box-shadow: \n        0 8px 24px rgba(239, 68, 68, 0.2),\n        inset 0 1px 1px rgba(255, 255, 255, 0.08);\n}\n\n.ssh-slate-item::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 3px;\n    background: linear-gradient(180deg, #8b5cf6, #3b82f6);\n    opacity: 0.5;\n    transition: opacity 0.3s ease;\n}\n\n.ssh-slate-item:hover::before {\n    opacity: 1;\n}\n\n.ssh-empty-state-redesign {\n    padding: 2rem 1rem;\n    text-align: center;\n}\n\n.ssh-empty-main {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: var(--text-main);\n    margin: 0 0 0.5rem 0;\n}\n\n.ssh-empty-sub {\n    font-size: 0.8rem;\n    color: var(--text-muted);\n    margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
